import { ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalRoot, ModalTitle } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TJsonQuery } from '../../../../packages/JsonQuery';
import { closeOfferPreview } from '../../../common/actions/closeOfferPreview/closeOfferPreview';
import { closeMobileListing } from '../../../common/actions/listingModal';
import { ETestId } from '../../../common/constants';
import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED } from '../../../common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../../common/hooks/useUxFbPoll/localStorageUtils';
import { selectIsModalOpen } from '../../../common/selectors/listingModal';
import { selectRegionDisplayName } from '../../../common/selectors/region/selectRegionDisplayName';
import { selectRegions } from '../../../common/selectors/regions';
import { TThunkDispatch } from '../../../common/types/redux';
import { applyRegionFilter } from '../../actions/applyRegionFilter';
import { Chip, ChipText } from '../../components/RedesignedFilters';
import { RegionSelectContainerModal } from '../RegionSelectContainer';

export const RegionChipContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const context = useApplicationContext();
  const deviceType = useDeviceType();
  const { logger } = context;

  const regionName = useSelector(selectRegionDisplayName);
  const regions = useSelector(selectRegions);
  const isListingModalOpen = useSelector(selectIsModalOpen);

  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED,
  );

  const [isOpen, setIsOpen] = React.useState(false);

  const handleFilterOpen = React.useCallback(() => {
    setIsOpen(true);
    dispatch(closeOfferPreview());
    dispatch(closeMobileListing());
  }, [dispatch]);

  const handleFilterApply = React.useCallback(
    async (nextJsonQuery?: TJsonQuery) => {
      // Закроется модалка
      setIsOpen(false);

      // Эта ветка отвечает за кейс, когда модалку закрыли без изменения гео
      if (!nextJsonQuery) {
        return;
      }

      await dispatch(
        applyRegionFilter({
          jsonQuery: nextJsonQuery,
          deviceType,
          pageType: isListingModalOpen ? 'Listing' : 'Map',
        }),
      );

      //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
      if (!isLocalStorageFiltersWereAppliedTwoTimes) {
        setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED);
      }
    },
    [deviceType, dispatch, isLocalStorageFiltersWereAppliedTwoTimes],
  );

  return (
    <ModalRoot open={isOpen} onOpenChange={setIsOpen}>
      <Chip onClick={handleFilterOpen} isSelected={Boolean(regionName)} testId={ETestId.RedesignedFiltersRegionChip}>
        <ChipText>{regionName || 'Область карты'}</ChipText>
      </Chip>
      <ModalContent>
        <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
        <ModalHeader>
          <ModalTitle>Введите регион или город</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <RegionSelectContainerModal logger={logger} regions={regions} onClose={handleFilterApply} />
        </ModalBody>
      </ModalContent>
    </ModalRoot>
  );
};
